import {Selector} from 'x.vue.components.ui';
import {CalculatorWoods_, board} from './mixins.js';
import './cw.css';

export const CalculatorWoods_tboard = {
    mixins: [CalculatorWoods_, board],
    components: {selector: Selector},
    data () {
        return {
            config: {
                steps: 2
            },
            vars: {
                shapes: {
                        rect: {
                                'title': 'Прямоугольная',
                                'img': '/local/js/tn/calculator/woods/img/rect.png',
                                'params': [
                                    {
                                        'title': 'Длина, м',
                                        'name': 'long',
                                        'type': 'number'
                                    },
                                    {
                                        'title': 'Ширина, м',
                                        'name': 'width',
                                        'type': 'number'
                                    }
                                ]
                            },
                        lform: {
                                'title': 'Г-образная',
                                'img': '/local/js/tn/calculator/woods/img/lform.png',
                                'params': [
                                    {
                                        'title': 'Длина, м',
                                        'name': 'long',
                                        'type': 'number'
                                    },
                                    {
                                        'title': 'Ширина, м',
                                        'name': 'width',
                                        'type': 'number'
                                    },
                                    {
                                        'title': 'Длина поворота, м',
                                        'name': 'llong',
                                        'type': 'number'
                                    },
                                    {
                                        'title': 'Ширина поворота, м',
                                        'name': 'lwidth',
                                        'type': 'number'
                                    }
                                ]
                            }
                },
                
                variants: {
                        longitudinal: {
                                'title': 'Продольный',
                                'img': '/local/js/tn/calculator/woods/img/longitudinal.png',
                                'K': 1.15
                            },
                        diagonal: {
                                'title': 'Диагональный',
                                'img': '/local/js/tn/calculator/woods/img/diagonal.png',
                                'K': 1.25
                            }
                },
                
                boards: {
                        tb27_142_2000: {
                                'title': 'Террасная доска 27 х 142 х 2000',
                                'H': 0.142,
                                'L': 2
                            },
                        tb27_142_3000: {
                                'title': 'Террасная доска 27 х 142 х 3000',
                                'H': 0.142,
                                'L': 3
                            },
                        tb27_142_4000: {
                                'title': 'Террасная доска 27 х 142 х 4000',
                                'H': 0.142,
                                'L': 4
                            },
                        pb28_90_2000: {
                                'title': 'Террасная доска 28 х 90 х 2000',
                                'H': 0.09,
                                'L': 2
                            },
                        pb28_90_3000: {
                                'title': 'Террасная доска 28 х 90 х 3000',
                                'H': 0.09,
                                'L': 3
                            },
                        pb28_90_4000: {
                                'title': 'Террасная доска 28 х 90 х 4000',
                                'H': 0.09,
                                'L': 4
                            },
                        pb28_96_2000: {
                                'title': 'Террасная доска 28 х 96 х 2000',
                                'H': 0.096,
                                'L': 2
                            },
                        pb28_96_3000: {
                                'title': 'Террасная доска 28 х 96 х 3000',
                                'H': 0.096,
                                'L': 3
                            },
                        pb28_96_4000: {
                                'title': 'Террасная доска 28 х 96 х 4000',
                                'H': 0.096,
                        },
                        pb28_140_2000: {
                                'title': 'Террасная доска 28 х 140 х 2000',
                                'H': 0.140,
                                'L': 2
                            },
                        pb28_140_3000: {
                                'title': 'Террасная доска 28 х 140 х 3000',
                                'H': 0.140,
                                'L': 3
                            },
                        pb28_140_4000: {
                                'title': 'Террасная доска 28 х 140 х 4000',
                                'H': 0.140,
                        }
                },
            },
            form: {},
        }
    },
    created () {
        this.form.shape = this.form.shape || 'rect';
        this.form.gap = this.form.gap || 5;
        this.form.variant = this.form.variant || 'longitudinal';

    },
    computed: {
        shape () {
            return this.form.shape?this.vars.shapes[this.form.shape]:false
        },
        variant () {
            return this.form.variant?this.vars.variants[this.form.variant]:false
        },
        
        a () {
            return this.form.long||0;
        },
        b () {
            return this.form.width||0;
        },
        c () {
            if (this.form.shape != 'lform') return 0;
            return this.form.llong||0;
        },
        d () {
            if (this.form.shape != 'lform') return 0;
            return this.form.lwidth||0;
        },
        
        variant () {
            return this.form.variant?this.vars.variants[this.form.variant]:false
        },
        K () {
            if (this.variant) {
                return this.variant.K
            }
            return 0;
        },
        Z () {
            let Z = parseInt(this.form.gap)/1000;
            return Z||0;
        },
        N () {
            let devision = ((this.bH+this.Z)*this.bL);
            return devision?((this.a*this.b - (this.b-this.d)*this.c)*this.K/devision):0;
        },
        
        
        result () {
            let result = {
                    rows: [],
                    errors: [],
                    total: 0
                };
            /////////////////////////// шаг 2
            if (this.shape) {
                result.rows.push({
                        'title': 'Форма террасы',
                        'value': this.shape.title,
                    });
            } else {
                result.errors.push({
                        'text': 'Выбирите форму террасы',
                        'step': 1,
                    });
            }
            
            if (this.a) {
                result.rows.push({
                        'title': 'Длина, м',
                        'value': this.a,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите длину',
                        'step': 1,
                    });
            }
            
            if (this.b) {
                result.rows.push({
                        'title': 'Ширина, м',
                        'value': this.b,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите ширину',
                        'step': 1,
                    });
            }
            
            if (this.form.shape == 'lform') {
                if (this.c) {
                    result.rows.push({
                            'title': 'Длина поворота, м',
                            'value': this.c,
                        });
                } else {
                    result.errors.push({
                            'text': 'Укажите длину поворота',
                            'step': 1,
                        });
                }
                
                if (this.d) {
                    result.rows.push({
                            'title': 'Ширина поворота, м',
                            'value': this.d,
                        });
                } else {
                    result.errors.push({
                            'text': 'Укажите ширину поворота',
                            'step': 1,
                        });
                }
            }
            /////////////////////////// шаг 3
            if (this.variant) {
                result.rows.push({
                        'title': 'Вариант укладки',
                        'value': this.variant.title,
                    });
            } else {
                result.errors.push({
                        'text': 'Выбирите вариант укладки',
                        'step': 2,
                    });
            }
            if (this.board) {
                result.rows.push({
                        'title': 'Материал настила',
                        'value': this.board.title,
                    });
            } else {
                result.errors.push({
                        'text': 'Выбирите материал настила',
                        'step': 2,
                    });
            }
            if (this.form.gap) {
                result.rows.push({
                        'title': 'Зазор между досками',
                        'value': this.form.gap,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите зазор',
                        'step': 2,
                    });
            }
            
            ///////////////////////// результат
            result.total = Math.ceil(this.N);
            
            return result;
        }
    },
	template: `
	<div>
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 1"
            >
            <a v-bind:name="'step'+(1+stepg-step)"></a>
            
            <div class="calculator__info">
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Выбирите форму террасы</span>
                </div>
            </div>
            
            <div class="tn-cw-radimg tboard-items">
                <div
                        v-for="(shape,val) in vars.shapes"
                        v-bind:id="'vars_shape_'+val"
                        v-bind:key="'vars_shape_'+val"
                        v-bind:class="{active: val == form.shape}"
                        v-on:click="form.shape = val"
                        class="tboard-item"
                    >

                    
                    <label class="tboard-label" v-bind:for="'vars_shape_'+val">
                        {{shape.title}}
                    </label>
                    <div class="tboard-img">
                        <img v-bind:src="shape.img" v-bind:alt="shape.title">
                    </div>
                    
                    
                </div>
            </div>
            
            <div class="params" v-if="form.shape">
                <label
                        v-for="param in vars.shapes[form.shape].params"
                        class="params-label"
                    >
                    {{param.title}}
                    <input v-bind:type="param.type" v-model="form[param.name]" placeholder="0">
                </label>
            </div>
        </div>
        
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 2"
            >
            <a v-bind:name="'step'+(2+stepg-step)"></a>
            
            <div class="calculator__info">
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Выбирите вариант укладки</span>
                </div>
            </div>

            <div class="tn-cw-radimg tboard-items">
                <div
                        v-for="(variant,val) in vars.variants"
                        v-bind:id="'vars_variant_'+val"
                        v-bind:key="'vars_variant_'+val"
                        v-bind:class="{active: val == form.variant}"
                        v-on:click="form.variant = val"
                        class="tboard-item"
                    >
                    
                    <label class="tboard-label" v-bind:for="'vars_variant_'+val">
                        {{variant.title}}
                    </label>
                    <div class="tboard-img">
                        <img v-bind:src="variant.img" v-bind:alt="variant.title">
                    </div>
                </div>
            </div>
            
            <div class="params">
                <label class="params-select">
                    <span class="params-name">Материал настила:</span>
                    <selector v-model="form.board"
                            v-bind:options="vars.boards"
                            titlekey="title"
                            placeholder="Выбирите материал"
                        />
                </label>

                <div>
                    <span class="params-name">Ширина зазора:</span>
                    <div class="params-radio">
                        <label class="params-radio-label">
                            <input type="radio" name="gap" v-model="form.gap" value="5">
                            <span class="params-choice">
                                <i></i>
                                <span> 5 мм</span>
                            </span>
                        </label>
                        <label class="params-radio-label">
                            <input type="radio" name="gap" v-model="form.gap" value="8">
                            <span class="params-choice">
                                <i></i>
                                <span> 8 мм</span>
                            </span>
                        </label>
                    </div>
                </div>
                
            </div>
        </div>
        
    </div>
	`
}